import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useOpts } from '../../context';
import { selectIsLoginDefaultStep } from '../../state/slices/slice-link-api';
import TermsOfService from '../../TermsOfService';
/**
 * Private React hook for returning a boolean value that represents
 * when we should show terms.
 *
 * @returns boolean - showTerms
 */
var useJobTermsFooter = function () {
    var skipIntroScreen = useOpts().linkTokenPayload.skipIntroScreen;
    var isLoginDefaultStep = useSelector(selectIsLoginDefaultStep);
    var showTerms = useMemo(function () { return skipIntroScreen && isLoginDefaultStep; }, [skipIntroScreen, isLoginDefaultStep]);
    return showTerms;
};
/**
 * Terms footer that renders only for login job default step when the intro
 * screen is skipped.
 *
 * @returns JSX.Element
 */
function JobTermsFooter() {
    var showTerms = useJobTermsFooter();
    if (!showTerms)
        return null;
    return React.createElement(TermsOfService, null);
}
export default JobTermsFooter;
